var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mdb-navbar',{attrs:{"expand":"large","dark":"","color":"info-color-dark"}},[_c('mdb-navbar-brand',{attrs:{"to":"/admin"}},[_vm._v(" Administration ")]),_c('mdb-navbar-toggler',[_c('mdb-navbar-nav',[_c('mdb-nav-item',{attrs:{"to":"/adminuser"}},[_vm._v("Utilisateurs")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }